import React from 'react';
import InvestorDashContentSC, { TableContentWrapSC } from './investor-dash-content.styled';
import InvestmentsTable from '../investments-table';
import { withRouter } from 'react-router-dom';

const InvestorDashContent = () => {
  return (
    <InvestorDashContentSC>
      <TableContentWrapSC>
        <InvestmentsTable itemsPerPage={3} hasAdditionalTop hasLinkOnAll allowStatuses={false} />
      </TableContentWrapSC>
    </InvestorDashContentSC>
  );
};

export default withRouter(InvestorDashContent);
